import { guardChildNodeByType, parseChildren, tableHtmlParsers, headingHtmlParsers, paragraphHtmlParsers, simpleHtmlParsers } from '@utils/ast';
import { configRefs } from '@utils/constants';
import { parseCaption, parseCaptionDisplayMode } from './util.parse-caption.js';
import { parsePm2Data } from './util.parse-pm2-data.js';

const parseImageComponent = (node, context) => {
  const caption = parseCaption(node);
  const pm2 = parsePm2Data(node, caption);
  if (!pm2) {
    return null;
  }
  const linkHref = node.getAttribute("internalLink") || node.getAttribute("externalLink");
  const imageTextNode = Array.from(node.childNodes).find(
    guardChildNodeByType("ImageText")
  );
  const imageAlt = (() => {
    const base = node.getAttribute("alt");
    if (!base) {
      return null;
    }
    if (node.getAttribute("altIsAiGenerated") === "true") {
      return `${base} (AI-tekst, muligvis ukorrekt)`;
    } else {
      return base;
    }
  })();
  return {
    nodeType: "image-component",
    id: node.getAttribute("id") ?? void 0,
    pm2: {
      ...pm2,
      transcript: imageTextNode ? parseChildren(
        imageTextNode,
        {
          ...simpleHtmlParsers,
          ...paragraphHtmlParsers,
          ...headingHtmlParsers,
          ...tableHtmlParsers
        },
        context.depth + 1
      ) : void 0,
      // if openInLightbox is enabled, then we will by default open the image
      // in lightbox when user clicks anywhere on the image itself; only if a
      // link is associated on click do we need to enable the button inside the
      // toolbar
      enableLightboxButton: linkHref ? pm2.enableLightboxButton : false
    },
    meta: {
      caption,
      alt: imageAlt || void 0,
      imageWidth: parseInt(node.getAttribute("width") || "", 10) || void 0,
      imageHeight: parseInt(node.getAttribute("height") || "", 10) || void 0
    },
    options: {
      displayCaption: parseCaptionDisplayMode(node),
      enableScaling: node.getAttribute("displaySize") !== "original",
      enableFullWidth: node.getAttribute("displaySize") === "fullWidth",
      enlargeOnClick: node.getAttribute("openInLightbox") === "true"
    },
    imageSrc: `${configRefs.apis.pm2.media.dangerouslyAssertSyncValue()}/${node.getAttribute("src")}`,
    link: linkHref ? {
      href: linkHref,
      target: (() => {
        switch (node.getAttribute("target")) {
          case "new-window":
            return "_blank";
          case "lightbox":
            return "_lightbox";
        }
      })()
    } : void 0
  };
};
const parseEmptyImage = () => {
  return {
    nodeType: "empty-image-component"
  };
};
const imageComponentParsers = {
  image: parseImageComponent,
  emptyimage: parseEmptyImage
};

export { imageComponentParsers, parseImageComponent };
//# sourceMappingURL=component.image.js.map
